// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const SmallDragonSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'small-dragon-attack',
    metadata: {
      frames: {
        'small-dragon-attack-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'small-dragon-attack-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'small-dragon-attack-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/small-dragon/attack.png',
        size: {
          w: 384,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'small-dragon-attack': [
          'small-dragon-attack-0',
          'small-dragon-attack-1',
          'small-dragon-attack-2',
        ],
      },
    },
  },
  {
    name: 'small-dragon-die',
    metadata: {
      frames: {
        'small-dragon-die-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'small-dragon-die-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'small-dragon-die-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'small-dragon-die-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/small-dragon/die.png',
        size: {
          w: 512,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'small-dragon-die': [
          'small-dragon-die-0',
          'small-dragon-die-1',
          'small-dragon-die-2',
          'small-dragon-die-3',
        ],
      },
    },
  },
  {
    name: 'small-dragon-fireAttack',
    metadata: {
      frames: {
        'small-dragon-fireAttack-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'small-dragon-fireAttack-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'small-dragon-fireAttack-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'small-dragon-fireAttack-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'small-dragon-fireAttack-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'small-dragon-fireAttack-5': {
          frame: {
            x: 320,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'small-dragon-fireAttack-6': {
          frame: {
            x: 384,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'small-dragon-fireAttack-7': {
          frame: {
            x: 448,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'small-dragon-fireAttack-8': {
          frame: {
            x: 512,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/small-dragon/fireAttack.png',
        size: {
          w: 576,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'small-dragon-fireAttack': [
          'small-dragon-fireAttack-0',
          'small-dragon-fireAttack-1',
          'small-dragon-fireAttack-2',
          'small-dragon-fireAttack-3',
          'small-dragon-fireAttack-4',
          'small-dragon-fireAttack-5',
          'small-dragon-fireAttack-6',
          'small-dragon-fireAttack-7',
          'small-dragon-fireAttack-8',
        ],
      },
    },
  },
  {
    name: 'small-dragon-exhaust',
    metadata: {
      frames: {
        'small-dragon-exhaust-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'small-dragon-exhaust-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/small-dragon/exhaust.png',
        size: {
          w: 256,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'small-dragon-exhaust': [
          'small-dragon-exhaust-0',
          'small-dragon-exhaust-1',
        ],
      },
    },
  },
  {
    name: 'small-dragon-idle',
    metadata: {
      frames: {
        'small-dragon-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'small-dragon-idle-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'small-dragon-idle-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/small-dragon/idle.png',
        size: {
          w: 384,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'small-dragon-idle': [
          'small-dragon-idle-0',
          'small-dragon-idle-1',
          'small-dragon-idle-2',
        ],
      },
    },
  },
  {
    name: 'small-dragon-run',
    metadata: {
      frames: {
        'small-dragon-run-0': {
          frame: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'small-dragon-run-1': {
          frame: {
            x: 128,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'small-dragon-run-2': {
          frame: {
            x: 256,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
        'small-dragon-run-3': {
          frame: {
            x: 384,
            y: 0,
            w: 128,
            h: 128,
          },
          sourceSize: {
            w: 128,
            h: 128,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 128,
            h: 128,
          },
        },
      },
      meta: {
        image: '/sprites/entities/small-dragon/run.png',
        size: {
          w: 512,
          h: 128,
        },
        scale: '1',
      },
      animations: {
        'small-dragon-run': [
          'small-dragon-run-0',
          'small-dragon-run-1',
          'small-dragon-run-2',
          'small-dragon-run-3',
        ],
      },
    },
  },
];
